import * as moment from "moment";

export function formatDateTime(datetime?: Date | string | null | undefined) {
  if (datetime) {
    return moment(datetime, 'YYYY-MM-DDTHH:mm:ss').format('MMM YY, hh:mm A');
  }

  return null;
}



// WEBPACK FOOTER //
// ./src/app/modules/uq-ui/helpers/datetimeFormatter.ts